export interface ModuleDependencyRuleLike {
  depends_on_module_id: string
}

export interface ModuleLike {
  id: string
  template_name: string
  dependencies: ModuleDependencyRuleLike[]
}

export interface ModuleCompletionLike {
  projectModuleId: string
  completed: boolean
}

export interface ModuleDependencyLockState {
  isEditable: boolean
  unmetDependencyModuleIds: string[]
  unmetDependencyNames: string[]
  lockReason: string | null
}

export function getModuleCompletionMap(moduleCompletions: ModuleCompletionLike[]): Map<string, boolean> {
  const map = new Map<string, boolean>()
  for (const completion of moduleCompletions) {
    map.set(completion.projectModuleId, completion.completed)
  }
  return map
}

export function getModuleDependencyLockMap(
  modules: ModuleLike[],
  completionMap: Map<string, boolean>
): Map<string, ModuleDependencyLockState> {
  const moduleNameById = new Map(modules.map((module) => [module.id, module.template_name]))
  const locks = new Map<string, ModuleDependencyLockState>()

  for (const module of modules) {
    const unmetIds = Array.from(
      new Set(
        module.dependencies
          .map((dependency) => dependency.depends_on_module_id)
          .filter((dependencyModuleId) => completionMap.get(dependencyModuleId) !== true)
      )
    )
    const unmetNames = unmetIds.map(
      (dependencyModuleId) => moduleNameById.get(dependencyModuleId) ?? dependencyModuleId
    )
    const isEditable = unmetIds.length === 0
    const lockReason = isEditable
      ? null
      : `Complete prerequisite module${unmetNames.length === 1 ? "" : "s"}: ${unmetNames.join(", ")}`

    locks.set(module.id, {
      isEditable,
      unmetDependencyModuleIds: unmetIds,
      unmetDependencyNames: unmetNames,
      lockReason
    })
  }

  return locks
}
